import React from 'react';
import "./Header.css"

const Header = () => {
  return (
    <div className="header">
      <h1>MEALLY</h1>
      <p>your reciept journal</p>
    </div>
  );
};

export default Header;